import React from "react";
import { useAuth0 } from "@auth0/auth0-react";


const BotResponse = ({ data, showDialogCodes }) => {
    const { user } = useAuth0();
    let user_profile=user?.oi_profile?.toLowerCase() 
    return (
        <div
            style={{
                display: "flex",
                maxWidth: "80%",
                minWidth: "80%",
                flexDirection: "column"
            }}
        >
            <center
                style={{
                    backgroundColor:user_profile=="demo"?"lightblue": "#FA6F57",
                    color:user_profile=="demo"?"black": "white",
                    fontSize: "9px",
                    // verticalAlign: "center",
                    padding: "5px",
                }}
                className="img-circle"
            >
                AI
            </center>
            {/* <img src="http://placehold.it/25/FA6F57/fff&text=U" alt="AI" class="img-circle" /> */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    background:user_profile=="demo"?"lightblue": "#035D91",
                    color:user_profile=="demo"?"black": "#FFFFFF",
                    marginLeft: "10px",
                    padding: "0.1rem 1.7rem 0.1rem 1rem",
                    borderRadius: "0 5rem 5rem",
                    maxWidth: "60%",
                    minWidth: "60%",
                }}
            >
                <div className="chatMessage" style={{ alignSelf: "flex-start" }}>
                    {data.utterance}{" "} {data.original_text && data.original_text != data.utterance && <>({data.original_text})</>}
                </div>
                <div className="chatTimingBot" style={{ alignSelf: "flex-end" ,color: user_profile=="demo" && "black"}}>
                    {new Date(data.creation_date).toLocaleString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                    })} 
                </div>

            </div>
            {(showDialogCodes || user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer"&& user?.oi_profile?.toLowerCase() !== "demo") && <div className="botUtteranceIntent">
                {data.system_response_code}
            </div>}
        </div>
    );
};

export default BotResponse;
